<template>
  <div>
    <Header></Header>
    <div class='content'>
      <div class='service'>
        <div class='img'><img src='../assets/img/joiningProcess/1.jpg' alt=''></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'JoiningProcess',
  components: {Header, Footer},
  data () {
    return {
      msg: 'joiningProcess'
    }
  }
}
</script>
<style>
  .content {
    width: 100%;
    height: auto;
    text-align: center;
    /*margin-top:2em;*/
  }
</style>
